const CONFIG_DEV = {
  appName: "STRATES-VIEWER",
  version: "07-2021",
  // apiBaseUrl: "https://strates-vs.crealp.ch/dev/strates-api",
  // apiBaseUrl: "http://localhost:8090",
  apiBaseUrl: "https://strates-vs.crealp.ch/strates-api",
  frontendBaseUrl: "/dev/viewer",
  legendBaseUrl: "",
  apiMgmtBaseUrl: "https://strates-vs.crealp.ch/mgmt-api",
  //apiMgmtBaseUrl: "http://localhost:8091",
  mapConfiguration: {
    projection: "EPSG:2056",
    center: [2610000, 1115000],
    view: {
      extent: [2550000, 1100000, 2700000, 1155000],
      zoom: 17,
      minZoom: 17,
      maxZoom: 39,
    },
    defaultBackgroundLayer: "ch.swisstopo.swissimage",
  },
  featureConfiguration: {
    layerSelectionType: "multi",
  },
  layerConfiguration: {
    opacityWhenNotFocus: 0.5,
  },
  tool: {
    vectorInfo: {
      fieldPrefixDisplay: "",
    },
  },

  websiteFooter: {
    name: "vs.ch/web/sen/eaux-souterraines",

    url: "https://www.vs.ch/web/sen/eaux-souterraines",
  },
};

const CONFIG_PROD = {
  appName: "STRATES-VIEWER",

  version: "07-2021",

  apiBaseUrl: "https://strates-vs.crealp.ch/strates-api",

  frontendBaseUrl: "/viewer",

  legendBaseUrl: "",

  apiMgmtBaseUrl: "https://strates-vs.crealp.ch/mgmt-api",

  mapConfiguration: {
    projection: "EPSG:2056",

    center: [2610000, 1115000],

    view: {
      extent: [2550000, 1100000, 2700000, 1155000],

      zoom: 17,

      minZoom: 17,

      maxZoom: 39,
    },

    defaultBackgroundLayer: "ch.swisstopo.swissimage",
  },

  featureConfiguration: {
    layerSelectionType: "uniqueOnLayerGroup",
  },

  layerConfiguration: {
    opacityWhenNotFocus: 0.5,
  },

  tool: {
    vectorInfo: {
      fieldPrefixDisplay: "",
    },
  },

  websiteFooter: {
    name: "vs.ch/web/sen/eaux-souterraines",

    url: "https://www.vs.ch/web/sen/eaux-souterraines",
  },
};

export default process.env.NODE_ENV === "development"
  ? CONFIG_DEV
  : CONFIG_PROD;
